import React from 'react'
import { Outlet } from 'react-router-dom'


const LoginLayout = () => {
    return (

        <main className="main h-100 w-100">
            <div className="container h-100">
                <div className="row h-100">
                    <div className="col-sm-10 col-md-8 col-lg-5 mx-auto d-table h-100">
                        <div className="d-table-cell align-middle">

                            <Outlet />

                        </div>
                    </div>
                </div>
            </div>
        </main>

    )
}

export default LoginLayout;